import React, { useCallback, useState } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import Header from "../../components/Header";
import HelpChatPanel from "../../components/HelpChatPanel";
import { SUPPORT_PHONE_NUMBER } from "../../constants/support";

const CHAT_URL = "https://tawk.to/chat/5e39c317a89cda5a18841f2d/1j48pl8n0";

const ChatPage = ({ history, token }) => {
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [isOpening, setIsOpening] = useState(false);
  const showLegacyPrompt = false;

  const goBack = useCallback(() => history.goBack(), [history]);

  // Guarded: never call twice for the same click
  const openExternal = useCallback((e) => {
    e?.preventDefault?.();
    e?.stopPropagation?.();
    if (isOpening) return;
    setIsOpening(true);
    // Try new tab / in-app browser; if blocked, DO NOT navigate here.
    // We'll leave the modal open so the user can choose "Open Here Instead".
    const win = window.open(CHAT_URL, "_blank", "noopener,noreferrer");
    if (win) {
      setConfirmOpen(false);
      setIsOpening(false);
    } else {
      setIsOpening(false); // popup blocked; keep modal visible
    }
  }, [isOpening]);

  const cancel = useCallback(() => {
    // Either just close the modal or go back; choose your UX
    setConfirmOpen(false);
    // Or: goBack();
  }, []);

  return (
    <div>
      <Header />
      <div className="chat-page-container" style={{ position: "relative" }}>
        {/* Back button */}
        <div className="back-button-container" style={{ padding: 12 }}>
          <button type="button" onClick={goBack} className="back-button" aria-label="Go back" title="Back">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                 xmlns="http://www.w3.org/2000/svg">
              <path d="M15 19l-7-7 7-7" stroke="#333" strokeWidth="2"
                    strokeLinecap="round" strokeLinejoin="round" />
              <line x1="8" y1="12" x2="20" y2="12" stroke="#333" strokeWidth="2"
                    strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </button>
        </div>

        {/* Optional placeholder card */}
        <div style={{
          maxWidth: 720, margin: "40px auto", padding: 16, borderRadius: 12,
          border: "1px solid #eef2f7", boxShadow: "0 6px 24px rgba(0,0,0,0.06)",
          textAlign: "center", fontFamily: "system-ui,-apple-system,Segoe UI,Roboto,Helvetica,Arial,sans-serif"
        }}>
          <h2 style={{ margin: "8px 0 4px" }}>Customer Support</h2>
          <p style={{ margin: 0, color: "#4b5563" }}>
            Open chat in a new page or here in this tab.
          </p>
        </div>

        <div style={{ display: "flex", justifyContent: "center", margin: "24px 0 40px" }}>
          <HelpChatPanel
            accessToken={token}
            handoffUrl={CHAT_URL}
            phoneNumber={SUPPORT_PHONE_NUMBER}
            title="Support chat"
          />
        </div>

        {/* Confirm modal (legacy Tawk flow) */}
        {confirmOpen && showLegacyPrompt && (
          <div
            role="dialog"
            aria-modal="true"
            aria-label="Open customer support"
            style={modalBackdrop}
            onClick={(e) => e.target === e.currentTarget && cancel()}
          >
            <div style={modalCard} onClick={(e) => e.stopPropagation()}>
              <div style={modalHeader}>
                <strong>Open Customer Support?</strong>
                <button type="button" onClick={cancel} style={xBtn} aria-label="Cancel">×</button>
              </div>
              <div style={modalBody}>
                We can open the chat in a new page (recommended) or in this page.
              </div>
              <div style={modalActions}>
                <button
                  id="chat-open-external"
                  type="button"
                  onClick={openExternal}
                  style={primaryBtn}
                  disabled={isOpening}
                >
                  {isOpening ? "Opening…" : "Open in New Page"}
                </button>
                {/* <button type="button" onClick={openInPlace} style={neutralBtn}>
                  Open Here Instead
                </button> */}
                <button type="button" onClick={cancel} style={secondaryBtn}>
                  Cancel
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

const modalBackdrop = {
  position: "fixed",
  inset: 0,
  background: "rgba(0,0,0,0.35)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 2147483647,
  WebkitTapHighlightColor: "transparent",
  pointerEvents: "auto",
};

const modalCard = {
  width: "min(92vw, 440px)",
  background: "#fff",
  borderRadius: 12,
  border: "1px solid #eef2f7",
  boxShadow: "0 20px 60px rgba(0,0,0,0.2)",
  overflow: "hidden",
  fontFamily: "system-ui,-apple-system,Segoe UI,Roboto,Helvetica,Arial,sans-serif",
};

const modalHeader = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "12px 14px",
  borderBottom: "1px solid #eee",
};

const xBtn = {
  border: "none",
  background: "transparent",
  fontSize: 20,
  cursor: "pointer",
  lineHeight: 1,
};

const modalBody = {
  padding: "14px",
  fontSize: 14,
  lineHeight: 1.5,
};

const modalActions = {
  display: "flex",
  gap: 8,
  justifyContent: "flex-end",
  padding: "12px 14px 16px",
  flexWrap: "wrap",
};

const baseBtn = {
  padding: "10px 14px",
  borderRadius: 8,
  fontSize: 14,
  cursor: "pointer",
};

const primaryBtn = {
  ...baseBtn,
  border: "1px solid #4C6EF8",
  background: "#4C6EF8",
  color: "#fff",
};

const secondaryBtn = {
  ...baseBtn,
  border: "1px solid #87A6EA",
  background: "white",
  color: "#87A6EA",
};

const mapStateToProps = (state) => ({
  token: state.token,
});

// export default withRouter(ChatPage);
export default connect(mapStateToProps)(withRouter(ChatPage));
